import { render } from "./DesktopHomeFrame.vue?vue&type=template&id=55d22c74&scoped=true"
import script from "./DesktopHomeFrame.vue?vue&type=script&lang=js"
export * from "./DesktopHomeFrame.vue?vue&type=script&lang=js"

import "./DesktopHomeFrame.vue?vue&type=style&index=0&id=55d22c74&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55d22c74"]])

export default __exports__